import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { IC_Assignment, IC_Template } from 'src/app/Interface/IC_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { ICService } from 'src/app/Service/IC/IC.service';

interface ICAssignmentRow extends IC_Assignment { template?: IC_Template; device?: any; }

@Component({ selector: 'app-ic-assignment-list', templateUrl: './ICAssignmentList.component.html', styleUrls: ['./ICAssignmentList.component.css'] })
export class ICAssignmentListComponent implements OnInit {
  rows: ICAssignmentRow[] = [];
  allRows: ICAssignmentRow[] = [];
  templateSearch = '';
  equipmentSearch = '';
  activeFilter: boolean | undefined = true;
  loading = false;
  toggling = false;
  page = 1;
  selectedRow?: ICAssignmentRow;
  modalRef: any;

  constructor(private service: ICService, private deviceService: DeviceBehfaService, private modalService: BsModalService, private router: Router, private alert: AlertifyService) {}
  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.page = 1;
    this.service.getAssignments(undefined, undefined, this.activeFilter).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: rows => { this.allRows = (rows || []) as ICAssignmentRow[]; this.applyFilters(); },
      error: () => this.alert.ErrorMessage('خطا در دریافت اطلاعات.')
    });
  }

  applyFilters(): void {
    this.page = 1;
    const templateKey = this.templateSearch.trim().toLowerCase();
    const equipmentKey = this.equipmentSearch.trim().toLowerCase();
    this.rows = this.allRows.filter(row => {
      const templateText = `${row.template?.iC_Code || ''} ${row.template?.iC_Title || ''}`.toLowerCase();
      const deviceText = `${row.device?.codeBEHFA || ''} ${row.device?.description || ''} ${row.device?.model || ''} ${row.device?.manufacturer || ''} ${row.deviceBehfa_ID}`.toLowerCase();
      return (!templateKey || templateText.includes(templateKey)) && (!equipmentKey || deviceText.includes(equipmentKey));
    });
  }

  clear(): void { this.templateSearch = ''; this.equipmentSearch = ''; this.activeFilter = true; this.load(); }
  add(): void { this.router.navigate(['/ic/assignment/add']); }
  detail(id: number): void { this.router.navigate(['/ic/assignment/detail', id]); }
  openToggleModal(template: TemplateRef<any>, row: ICAssignmentRow): void { this.selectedRow = row; this.modalRef = this.modalService.show(template); }
  confirmToggle(): void {
    if (!this.selectedRow || this.toggling) return;
    const active = !this.selectedRow.active;
    this.toggling = true;
    this.service.setAssignmentActive(this.selectedRow.id, active).pipe(finalize(() => this.toggling = false)).subscribe({
      next: () => { this.modalRef.hide(); this.alert.SuccessMessage(active ? 'تخصیص فعال شد.' : 'تخصیص غیرفعال شد.'); this.load(); },
      error: e => this.alert.ErrorMessage(e?.error?.message || 'تغییر وضعیت ناموفق بود.')
    });
  }
}
